var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _c(
        "q-card",
        { staticClass: "auth-card relative-position" },
        [
          _c(
            "q-card-main",
            [
              _vm.confirmed
                ? _c(
                    "div",
                    { staticClass: "text-center" },
                    [
                      _c("check-mark"),
                      _c("h4", [
                        _vm._v(_vm._s(_vm.$t("payment_confirmed_title")))
                      ]),
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t("payment_confirmed_body")))
                      ])
                    ],
                    1
                  )
                : [
                    _vm.paymentRequiresAction
                      ? _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c("h4", { staticClass: "q-mt-none q-mb-md" }, [
                              _vm._v(_vm._s(_vm.$t("confirm_payment_title")))
                            ]),
                            _c(
                              "i18n",
                              {
                                staticClass: "q-subheading",
                                attrs: {
                                  tag: "p",
                                  path: "confirm_payment_body"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "text-bold",
                                    attrs: { place: "amount" }
                                  },
                                  [_vm._v(_vm._s(_vm.paymentAmount))]
                                )
                              ]
                            ),
                            _c(
                              "q-btn",
                              {
                                staticClass: "q-mt-lg",
                                attrs: {
                                  color: "primary",
                                  loading: _vm.loading
                                },
                                on: { click: _vm.handleConfirmPayment }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("confirm")) +
                                    "\n          "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.paymentSucceeded
                      ? _c("div", { staticClass: "text-center" }, [
                          _c("h4", { staticClass: "q-mt-none q-mb-md" }, [
                            _vm._v(
                              _vm._s(_vm.$t("payment_already_confirmed_title"))
                            )
                          ]),
                          _c("p", { staticClass: "q-subheading" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("payment_already_confirmed_body")
                                ) +
                                "\n          "
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm.paymentCanceled
                      ? _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c("h4", { staticClass: "q-mt-none q-mb-md" }, [
                              _vm._v(_vm._s(_vm.$t("payment_canceled_title")))
                            ]),
                            _c("p", { staticClass: "q-subheading" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("payment_canceled_body")) +
                                  "\n          "
                              )
                            ]),
                            _c("support-btn")
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.paymentInvalid
                      ? _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c("h4", { staticClass: "q-mt-none q-mb-md" }, [
                              _vm._v(_vm._s(_vm.$t("payment_invalid_title")))
                            ]),
                            _c("p", { staticClass: "q-subheading" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("payment_invalid_body")) +
                                  "\n          "
                              )
                            ]),
                            _c("support-btn")
                          ],
                          1
                        )
                      : _vm._e()
                  ]
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center q-mb-xl" }, [
      _c("img", {
        staticStyle: { height: "25px" },
        attrs: { src: require("assets/logo.svg") }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }